module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-600.819af3d3.woff2";